import { ChatViewLayoutProps } from '../../../../layouts/chat-view-layout/ChatViewLayout';
import PromptList from '../../elements/prompt-list/PromptList';
import styles from './PromptManagementView.module.scss';

const PromptManagementView = (props: ChatViewLayoutProps) => {
    return <div className={styles['prompt-mgt-view']}>
        <PromptList {...props} />
    </div>;
};

export default PromptManagementView;